import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

let routes = [{
    path: '/',
    name: 'home',
    redirect: '/home'
},
{
    path: '',
    name: 'home',
    component: () =>
        import('@/views/index.vue'),
    children: [{
        path: '',
        redirect: 'home'
    },
    {
        path: 'home',
        name: 'Home',
        component: () =>
            import('@/views/home/index.vue'),
        meta: {
            activeMenu: 'home'
        }
    },
    {
        path: 'market',
        name: 'Market',
        component: () =>
            import('@/views/market/index.vue'),
        meta: {
            activeMenu: 'market'
        }
    },
    {
        path: 'mySelect',
        name: 'MySelect',
        component: () =>
            import('@/views/market/mySelect.vue'),
        meta: {
            activeMenu: 'mySelect'
        }
    },
    {
        path: 'login',
        name: 'Login',
        component: () =>
            import('@/views/login/index.vue'),
        meta: {
            activeMenu: 'login'
        }
    },
    {
        path: 'register',
        name: 'Register',
        component: () =>
            import('@/views/register/index.vue'),
        meta: {
            activeMenu: 'register'
        }
    },
    {
        path: 'forgotPassword',
        name: 'ForgotPassword',
        component: () =>
            import('@/views/forgotPassword/index.vue'),
        meta: {
            activeMenu: 'forgotPassword'
        }
    },
    {
        path: 'trade',
        name: 'Trade',
        component: () =>
            import('@/views/trade/index.vue'),
        meta: {
            activeMenu: 'trade'
        }
    },
    {
        path: 'position',
        name: 'Position',
        component: () =>
            import('@/views/position/index.vue'),
        meta: {
            activeMenu: 'position'
        }
    },
    {
        path: 'with',
        name: 'With',
        component: () =>
            import('@/views/with/index.vue'),
        meta: {
            activeMenu: 'with'
        }
    },
    {
        path: '/withCurrency',
        name: 'WithCurrency',
        meta: { tx: 3 },
        component: () =>
            import('@/views/with/currency')
    },
    {
        path: 'recharge',
        name: 'Recharge',
        component: () =>
            import('@/views/recharge/index.vue'),
        meta: {
            activeMenu: 'recharge'
        }
    },
    {
        path: '/rechargeCurrency',
        name: 'RechargeCurrency',
        meta: { tx: 3 },
        component: () =>
            import('@/views/recharge/currency')
    },
    {
        path: 'bill',
        name: 'Bill',
        component: () =>
            import('@/views/bill/index.vue'),
        meta: {
            activeMenu: 'bill'
        }
    },
    {
        path: 'notice',
        name: 'Notice',
        component: () =>
            import('@/views/notice/index.vue'),
        meta: {
            activeMenu: 'notice'
        }
    },
    {
        path: 'help',
        name: 'Help',
        component: () =>
            import('@/views/help/index.vue'),
        meta: {
            activeMenu: 'help'
        }
    },
    {
        path: 'detail',
        name: 'Detail',
        component: () =>
            import('@/views/detail/index.vue'),
        meta: {
            activeMenu: 'detail'
        }
    },
    {
        path: 'property',
        name: 'Property',
        component: () =>
            import('@/views/property/index.vue'),
        meta: {
            activeMenu: 'property'
        }
    },
    {
        path: 'propertyList',
        name: 'PropertyList',
        component: () =>
            import('@/views/property/propertyList.vue'),
        meta: {
            activeMenu: 'propertyList'
        }
    },
    {
        path: 'auth',
        name: 'Auth',
        component: () =>
            import('@/views/auth/index.vue'),
        meta: {
            activeMenu: 'auth'
        }
    },
    {
        path: '/highAuth',
        name: 'HighAuth',
        meta: { tx: 3 },
        component: () =>
            import('@/views/auth/highAuth')
    },
    {
        path: '/assetAuth',
        name: 'AssetAuth',
        meta: { tx: 3 },
        component: () =>
            import('@/views/auth/assetAuth')
    },
    {
        path: 'upPassword',
        name: 'UpPassword',
        component: () =>
            import('@/views/upPassword/index.vue'),
        meta: {
            activeMenu: 'upPassword'
        }
    },
    {
        path: 'share',
        name: 'Share',
        component: () =>
            import('@/views/share/index.vue'),
        meta: {
            activeMenu: 'share'
        }
    },
    {
        path: 'commissionList',
        name: 'CommissionList',
        component: () =>
            import('@/views/share/commissionList.vue'),
        meta: {
            activeMenu: 'commissionList'
        }
    },
    {
        path: 'rollOut',
        name: 'RollOut',
        component: () =>
            import('@/views/share/rollOut.vue'),
        meta: {
            activeMenu: 'rollOut'
        }
    },
    {
        path: 'rollOutList',
        name: 'RollOutList',
        component: () =>
            import('@/views/share/rollOutList.vue'),
        meta: {
            activeMenu: 'rollOutList'
        }
    },
    {
        path: 'invite',
        name: 'Invite',
        component: () =>
            import('@/views/share/invite.vue'),
        meta: {
            activeMenu: 'invite'
        }
    },
    {
        path: 'inviteList',
        name: 'InviteList',
        component: () =>
            import('@/views/share/inviteList.vue'),
        meta: {
            activeMenu: 'inviteList'
        }
    },
    {
        path: '/safe',
        name: 'Safe',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe')
    },
    {
        path: '/upLoginPwd',
        name: 'UpLoginPwd',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/upLoginPwd')
    },
    {
        path: '/upPayPwd',
        name: 'UpPayPwd',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/upPayPwd')
    },
    {
        path: '/bindEmail',
        name: 'BindEmail',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/bindEmail')
    },
    {
        path: '/bindPhone',
        name: 'BindPhone',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/bindPhone')
    },
    {
        path: '/walletAddress',
        name: 'WalletAddress',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/walletAddress')
    },
    {
        path: '/addWalletAddress',
        name: 'AddWalletAddress',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/addWalletAddress')
    },
    {
        path: '/about',
        name: 'About',
        meta: { tx: 2 },
        component: () =>
            import('@/views/about')
    },
    {
        path: '/head',
        name: 'Head',
        meta: { tx: 3 },
        component: () =>
            import('@/views/user/head')
    },
    {
        path: '/asset',
        name: 'Asset',
        meta: { keepAlive: true },
        component: () =>
            import('@/views/asset')
    },
    {
        path: '/assetTransfer',
        name: 'AssetTransfer',
        meta: { tx: 3 },
        component: () =>
            import('@/views/asset/transfer')
    },
    {
        path: '/assetFlashcash',
        name: 'AssetFlashcash',
        meta: { tx: 3 },
        component: () =>
            import('@/views/asset/flashcash')
    },
    {
        path: '/finance',
        name: 'Finance',
        meta: { tx: 3 },
        component: () =>
            import('@/views/finance')
    },
    {
        path: '/financeInfo',
        name: 'FinanceInfo',
        meta: { tx: 3 },
        component: () =>
            import('@/views/finance/info')
    },
    {
        path: '/financeList',
        name: 'FinanceList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/finance/list')
    },
    {
        path: '/financeOrderInfo',
        name: 'FinanceOrderInfo',
        meta: { tx: 3 },
        component: () =>
            import('@/views/finance/orderInfo')
    },
    {
        path: '/c2c',
        name: 'C2c',
        meta: { tx: 3 },
        component: () =>
            import('@/views/c2c')
    },
    {
        path: '/c2cBuy',
        name: 'C2cBuy',
        meta: { tx: 3 },
        component: () =>
            import('@/views/c2c/buy')
    },
    {
        path: '/c2cSell',
        name: 'C2cSell',
        meta: { tx: 3 },
        component: () =>
            import('@/views/c2c/sell')
    },
    {
        path: '/c2cOrder',
        name: 'C2cOrder',
        meta: { tx: 3 },
        component: () =>
            import('@/views/c2c/order')
    },
    {
        path: '/chat',
        name: 'Chat',
        meta: { tx: 3 },
        component: () =>
            import('@/views/chat')
    },
    {
        path: '/chatList',
        name: 'ChatList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/chat/list')
    },
    {
        path: '/activity',
        name: 'Activity',
        meta: { tx: 3 },
        component: () =>
            import('@/views/activity')
    },
    {
        path: '/inviteReward',
        name: 'InviteReward',
        meta: { tx: 3 },
        component: () =>
            import('@/views/activity/inviteReward')
    },
    {
        path: '/rechargeReward',
        name: 'RechargeReward',
        meta: { tx: 3 },
        component: () =>
            import('@/views/activity/rechargeReward')
    },
    {
        path: '/authReward',
        name: 'AuthReward',
        meta: { tx: 3 },
        component: () =>
            import('@/views/activity/authReward')
    },
    {
        path: '/loan',
        name: 'Loan',
        meta: { tx: 3 },
        component: () =>
            import('@/views/loan')
    },
    {
        path: '/loanList',
        name: 'LoanList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/loan/list')
    },
    ]
}
]

const router = new VueRouter({ routes: routes })

router.afterEach((to) => {
    localStorage.setItem('fullPath', to.fullPath)
    window.scrollTo(0, 0)
})
export default router